export default function styles() {
    return {
        alignItems: "center",
        display: "flex",
        flexDirection: "column" as "column"
    }
}